import { HYDRATE } from 'next-redux-wrapper';

import { ECategory } from '@r1-frontend/api-domru/api-profile/v1/spec-offer/update/dto/ResponseDto';

import type { InferValueTypes, THydrateAction } from '~/src/store';
import type * as ActionCreators from '~/src/store/actionCreators/promo';
import { ActionTypesPromo } from '~/src/store/actionTypes/promo';

export interface IPromoStore {
    category?: ECategory | '',
    isActive?: boolean,
    stepId?: number,
}

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

/**
 * Начальное состояние
 *
 * @name store.reducers.promo.initialState
 * @type {object}
 */
export const initialState = {};

/**
 * Reducer промо карточек
 *
 * @function
 * @name store.reducers.promo.reducer
 * @param {Record<number, IPromoStore> | typeof initialState} state - Текущее состояние
 * @param {TActions} action - Объект действия
 * @returns {Record<number, IPromoStore> | typeof initialState}
 */
export default function reducer(state = initialState, action: TActions): Record<number, IPromoStore> | typeof initialState {

    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.promo };
        case ActionTypesPromo.SET_CATEGORY_PROMO_CARD: {
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}
